module.exports = __webpack_public_path__ + "72ee5d7d1b3f38d8da59af7c1ca24768.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page (2).png
// module id = 1045
// module chunks = 0